import { useEffect, useMemo, useState } from "react";
import ModalCalculadora from "../ModalCalculadora/ModalCalculadora";
import { useComun } from "../../Hooks/useComun";
import useLogin from "../../Features/Autenticacion/Hooks/useLogin";
import { EnumAreaNegocio } from "../../Utils/Enumeradores/ComunEnum";
import "./GlobalFloatingCalculator.css";
const ALL_AREA_NEGOCIO_IDS = Object.values(EnumAreaNegocio).filter(
	(value) => typeof value === "number",
);

const GlobalFloatingCalculator = () => {
	const { usuario } = useLogin();
	const { listadoIndicadoresId, getListaIndicadoresId } = useComun();
	const [showCalculator, setShowCalculator] = useState(false);

	const indicatorOptions = useMemo(() => (
		Array.isArray(listadoIndicadoresId) ? listadoIndicadoresId : []
	), [listadoIndicadoresId]);

	useEffect(() => {
		if (!usuario?.id) {
			return;
		}

		getListaIndicadoresId(ALL_AREA_NEGOCIO_IDS);
	}, [getListaIndicadoresId, usuario?.id]);


	return (
		<>
			<button
				type="button"
				className={`global-floating-calculator ${showCalculator ? "is-open" : ""}`}
				onClick={() => setShowCalculator((previousState) => !previousState)}
				aria-label={showCalculator ? "Cerrar calculadora global" : "Abrir calculadora global"}
				aria-expanded={showCalculator}
			>
				<span className="global-floating-calculator__halo" aria-hidden="true" />
				<span className="global-floating-calculator__icon" aria-hidden="true">
					{showCalculator ? (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
						>
							<path
								d="M36 12L12 36M12 12L36 36"
								stroke="white"
								strokeWidth="4"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
						>
							<path
								d="M36 4H12C9.79086 4 8 5.79086 8 8V40C8 42.2091 9.79086 44 12 44H36C38.2091 44 40 42.2091 40 40V8C40 5.79086 38.2091 4 36 4Z"
								stroke="white"
								strokeWidth="4"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M16 12H32M32 28V36M32 20H32.02M24 20H24.02M16 20H16.02M24 28H24.02M16 28H16.02M24 36H24.02M16 36H16.02"
								stroke="white"
								strokeWidth="4"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</span>
			</button>

			<ModalCalculadora
				show={showCalculator}
				onHide={() => setShowCalculator(false)}
				title="Calculadora SICNS"
				subtitle="Consulta una proyeccion rapida del indicador seleccionado."
				resultTitle="RESULTADOS"
				indicatorLabel="Indicador"
				indicatorPlaceholder="Selecciona un indicador"
				indicatorOptions={indicatorOptions}
				isFloating
			/>
		</>
	);
};

export default GlobalFloatingCalculator;
